import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

const PermissionButton = ({ 
  children, 
  permission, 
  className = "", 
  disabled = false, 
  onClick, 
  title,
  style = {},
  ...props 
}) => {
  const { hasPermission } = usePermissions();
  
  const hasRequiredPermission = hasPermission(permission);
  const isDisabled = !hasRequiredPermission || disabled;
  
  const buttonStyle = {
    ...style,
    cursor: hasRequiredPermission ? "pointer" : "not-allowed",
    opacity: hasRequiredPermission ? 1 : 0.6
  };
  
  const buttonClassName = hasRequiredPermission 
    ? className 
    : className.replace(/btn-\w+/g, 'btn-secondary');
  
  const buttonTitle = hasRequiredPermission 
    ? title 
    : `ليس لديك صلاحية للقيام بهذا الإجراء`;
  
  const handleClick = (e) => {
    if (hasRequiredPermission && onClick) {
      onClick(e);
    }
  };
  
  return (
    <button
      {...props}
      className={buttonClassName}
      disabled={isDisabled}
      onClick={handleClick}
      title={buttonTitle}
      style={buttonStyle}
    >
      {children}
    </button>
  );
};

export default PermissionButton;
